import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../common/store'
import { AP_ZOOM_EXTENT_TYPES, APFrameDetailsType, APIErrorAware } from './ap.types'

export interface ApFramesState extends APIErrorAware {
  allFrameDetails: APFrameDetailsType[]
  visibleFrameDetails: APFrameDetailsType[]
  selectedFrameDetails?: APFrameDetailsType
  hoverFrameDetails?: APFrameDetailsType
  zoomExtentMode: AP_ZOOM_EXTENT_TYPES
  years?: number[]
  activeYear?: number
}

const initialState: ApFramesState = {
  allFrameDetails: [],
  visibleFrameDetails: [],
  zoomExtentMode: 'visibleFrames',
}

export const AP_FRAMES = 'apFrames'

export const apFramesSlice = createSlice({
  name: AP_FRAMES,
  initialState,
  reducers: {
    setAllFrames: (state, action: PayloadAction<APFrameDetailsType[]>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.allFrameDetails = action.payload
    },
    setVisibleFrames: (state, action: PayloadAction<APFrameDetailsType[]>) => {
      state.visibleFrameDetails = action.payload
    },
    setSelectFrame: (state, action: PayloadAction<APFrameDetailsType>) => {
      state.selectedFrameDetails = action.payload
    },
    clearSelectFrame: (state) => {
      state.selectedFrameDetails = undefined
    },
    setHoverFrame: (state, action: PayloadAction<APFrameDetailsType>) => {
      state.hoverFrameDetails = action.payload
    },
    clearHoverFrame: (state) => {
      state.hoverFrameDetails = undefined
    },
    setYears: (state, action: PayloadAction<number[]>) => {
      state.years = action.payload
    },
    setActiveYear: (state, action: PayloadAction<number>) => {
      state.activeYear = action.payload
    },
    setZoomExtentMode: (state, action: PayloadAction<AP_ZOOM_EXTENT_TYPES>) => {
      state.zoomExtentMode = action.payload
    },
  },
})

export const {
  setAllFrames,
  setVisibleFrames,
  setSelectFrame,
  clearSelectFrame,
  setHoverFrame,
  clearHoverFrame,
  setYears,
  setActiveYear,
  setZoomExtentMode,
} = apFramesSlice.actions

export const selectAllFrames = (state: RootState) => state[AP_FRAMES].allFrameDetails
export const selectVisibleFrames = (state: RootState) => state[AP_FRAMES].visibleFrameDetails
export const selectSelectedFrame = (state: RootState) => state[AP_FRAMES].selectedFrameDetails
export const selectHoverFrame = (state: RootState) => state[AP_FRAMES].hoverFrameDetails
export const selectYears = (state: RootState) => state[AP_FRAMES].years
export const selectActiveYear = (state: RootState) => state[AP_FRAMES].activeYear
export const selectZoomExtentMode = (state: RootState) => state[AP_FRAMES].zoomExtentMode